// File: src/pages/AdminPage.tsx

import React, {useState} from 'react';
import {Box, Paper, Tab, Tabs, Typography} from '@mui/material';

import UserManagementPanel from '../components/admin/UserManagementPanel';
import MarketplaceManagementPanel from '../components/admin/MarketplaceManagementPanel';
import AIServiceManagementPanel from '../components/admin/AIServiceManagementPanel';
import PromptTemplateManagementPanel from '../components/admin/PromptTemplateManagementPanel';


const AdminPage = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <Box sx={{p: 3}}>
            {/* +++ ДОБАВЛЕНО: Единый блок для заголовка +++ */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1">
                    Admin Panel
                </Typography>
            </Box>

            <Paper>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    sx={{borderBottom: 1, borderColor: 'divider'}}
                >
                    <Tab label="Users"/>
                    <Tab label="Marketplaces"/>
                    <Tab label="AI Services"/>
                    <Tab label="Prompt Templates"/>
                </Tabs>

                <Box sx={{p: 3}}>
                    {/* Render the content based on the selected tab */}
                    {tabValue === 0 && <UserManagementPanel/>}
                    {tabValue === 1 && <MarketplaceManagementPanel/>}
                    {tabValue === 2 && <AIServiceManagementPanel/>}
                    {tabValue === 3 && <PromptTemplateManagementPanel/>}
                </Box>
            </Paper>
        </Box>
    );
};

export default AdminPage;